import { useSelector } from 'react-redux';
import { useEffect } from 'react';
import axios from 'axios';
import * as R from 'ramda';
import { createSelector } from 'reselect';

import { getClientCode, getSessionKey } from 'reducers/Login';
import { getSelectedPosID } from 'reducers/PointsOfSale';
import { version } from 'external_data';
import { getMetricsCollectorFrequency } from 'reducers/cafaConfigs';
import { getMSEndpointFromLS } from 'reducers/installer';

const getConfiguration = createSelector(
  getMetricsCollectorFrequency,
  /*
    Low 'frequency' configuration may cause issues where the terminal is busy providing info to metrics collector (which takes up to 2 minutes) and may decline the payment request due to "Terminal being busy"
    Issue should have a proper fix and is being tracked in PBIB-8470
  */
  conf => conf ?? { frequency: 30 },
);
const getURL = () =>
  `${getMSEndpointFromLS('metrics-collector-ms') ||
    'https://localhost.erply.com:10901/'}api/v1`;

const getAxiosInstance = createSelector(getURL, url =>
  axios.create({
    baseURL: url,
  }),
);

const getHeaders = createSelector(getClientCode, getSessionKey, (cc, sk) => ({
  clientCode: cc,
  sessionKey: sk,
  'Content-Type': 'application/json',
}));

const getBody = createSelector(
  getSelectedPosID,
  getConfiguration,
  (posId, { frequency }) => {
    return {
      sendingDataPeriodMinutes: frequency,
      posId: posId ? String(posId) : posId,
      posVersion: `Brazil POS: ${version}`,
    };
  },
);

const getRequest = createSelector(
  getHeaders,
  getBody,
  getAxiosInstance,
  (headers, body, ax) =>
    // R.once wraps the function so that even if it is called multiple times (because the component is remounted) then the duplicate invocations will be ignored anyway.
    R.once(() => ax.post('/setMonitoringParameters', body, { headers })),
);

export const useMetricsCollector = () => {
  const { posId } = useSelector(getBody);
  const request = useSelector(getRequest);

  useEffect(() => {
    if (posId) {
      request();
    }
  }, [request, posId]);
};
